<span class="text-nowrap">
    <i *ngIf="draftCommentCount > 0" class="far fa-comment" title="Draft Comments"></i>
    <i *ngIf="publishedCommentCount > 0" class="far fa-comment-dots" title="Pulbished Comments"></i>
</span>
